import React, { Component, PropTypes } from 'react';
import { formatMessage, currencySymbol } from './localiser';

/*
 * Intl higher-order component (HOC) factory
 * Component for passing internationalisation props onto child component
 * @type {function} Intl
 */

export default function Intl(ComposedComponent, stringsTable) {
	return class extends Component {
		static propTypes = {
			locale: PropTypes.string.isRequired
		};
		constructor(props) {
			super(props);
			this.locale = props.locale;
			this.stringsTable = stringsTable;
			this.intl = this.getIntl();
		}
		getIntl() {
			return {
				locale: this.locale,
				formatMessage: (key, values) => {
					return formatMessage(this.stringsTable, key, this.locale, values);
				},
				formatCurrencySymbol: currencySymbol
			};
		}
		render() {
			return <ComposedComponent {...this.props} intl={this.intl} />;
		}
	};
}



// WEBPACK FOOTER //
// ../~/dna-react-intl/components/intl/Intl.js